import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { apiClientV1, apiClientV2, subgraphClientV1 } from '@/agent/apiClient/api';

import type { ReduxDispatch, ReduxState } from '../types/common.type';

export const useAppDispatch: () => ReduxDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<ReduxState> = useSelector;

export interface TArgs {
  path: string;
  version?: 'v1' | 'v2';
  type?: 'server' | 'subgraph';
  data?: AxiosRequestConfig['data'];
  method?: AxiosRequestConfig['method'];
  params?: AxiosRequestConfig['params'];
  headers?: AxiosRequestConfig['headers'];
  validateStatus?: AxiosRequestConfig['validateStatus'];
}

export const axiosBaseQuery: BaseQueryFn<TArgs, unknown, unknown> = async ({
  path,
  version = 'v2',
  type = 'server',
  method,
  data,
  params,
  headers,
  validateStatus,
}) => {
  const apiClient = version === 'v1' ? apiClientV1 : apiClientV2;
  const service = type === 'server' ? apiClient : subgraphClientV1;

  return service({ url: path, method, data, params, headers, validateStatus })
    .then(r => ({ data: r.data }))
    .catch((e: AxiosError) => ({
      error: {
        status: e.response?.status,
        data: e.response?.data || e.message,
      },
    }));
};
